import React from "react";
import { TextField } from "@mui/material";

interface TextInputProps {
  label: string;
  type?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const TextInput: React.FC<TextInputProps> = ({ label, type = "text", value, onChange }) => {
  return (
    <TextField
      label={label}
      variant="outlined"
      fullWidth
      type={type}
      value={value}
      onChange={onChange}
      required
    />
  );
};

export default TextInput;
